import React from "react"
import { HeaderProps } from "../interfaces"
import { Popover } from "@walmart-web/livingdesign-components"
import "./index.scss"
import { Icon } from "@walmart-web/livingdesign-icons"

const Header = (props: HeaderProps) => {
	const { iconName = "InfoCircle", iconSize = "small" } = props
	const [isOpen, setIsOpen] = React.useState(false)
	const buttonRef = React.useRef<HTMLButtonElement>(null)
	const renderTooltip = () => {
		return (
			<div className="container-tooltip">
				<Popover
					content={<div className="description-tooltip">{props.tooltip}</div>}
					onClose={() => setIsOpen(isOpen)}
					isOpen={isOpen}
					onMouseOut={() => setIsOpen(false)}
					position="top"
					triggerRef={buttonRef}
					hasNubbin
				>
					<div onMouseOver={() => setIsOpen(true)}>
						<Icon name={iconName} size={iconSize} />
					</div>
				</Popover>
			</div>
		)
	}

	return (
		<div className="title-card">
			<span>{props.title}</span>
			{props.tooltip && renderTooltip()}
		</div>
	)
}

export default Header
